import { QueryClient } from '@tanstack/react-query';
import { notifyTicketsChanged } from './ticketEvents';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30000, retry: 1 },
    mutations: { retry: 0 }
  }
});

// Puente: cualquier invalidación de una query de tickets avisa a las superficies que
// NO viven en react-query (la burbuja de tickets y el badge del sidebar tienen estado
// propio con poll de 60s). Va acá y no en los ~30 sitios que invalidan porque así el
// que agregue mañana una acción nueva sobre un ticket la hereda sin enterarse: sólo
// tiene que invalidar ['tickets'], que es lo que ya hace todo el mundo.
// Se agrupan los avisos: una acción masiva invalida varias queries de tickets de una y
// no tiene sentido pedir el contador cuatro veces seguidas.
let ticketsNotifyTimer = null;
queryClient.getQueryCache().subscribe(event => {
  if (event?.type !== 'updated') return;
  if (event.action?.type !== 'invalidate') return;
  if (event.query?.queryKey?.[0] !== 'tickets') return;
  if (ticketsNotifyTimer) return;
  ticketsNotifyTimer = setTimeout(() => { ticketsNotifyTimer = null; notifyTicketsChanged(); }, 300);
});

export default queryClient;
